import { useState } from "react";
import { Mail, Send } from "lucide-react";

export default function Newsletter() {
  const [email, setEmail] = useState("");

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="relative bg-brand-600 rounded-2xl overflow-hidden">
        {/* Decorative blur circles */}
        <div className="absolute -right-20 -top-20 w-64 h-64 bg-white/10 rounded-full blur-3xl" />
        <div className="absolute -left-10 -bottom-10 w-48 h-48 bg-brand-100/10 rounded-full blur-2xl" />

        <div className="relative p-8 md:p-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-xl bg-white/15 text-white flex items-center justify-center flex-shrink-0">
              <Mail size={22} />
            </div>
            <div className="text-white">
              <h2 className="text-xl md:text-2xl font-black">Restez informé</h2>
              <p className="text-white/85 text-sm mt-1 max-w-md">
                Abonnez-vous à notre newsletter pour recevoir les dernières infos voyage et offres.
              </p>
            </div>
          </div>

          <form
            onSubmit={(e) => e.preventDefault()}
            className="w-full md:w-auto flex gap-2"
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Votre adresse e-mail"
              className="flex-1 md:w-72 px-4 py-2.5 rounded-xl text-slate-800 text-sm focus:outline-none focus:ring-2 focus:ring-white/60"
            />
            <button
              type="submit"
              className="bg-white hover:bg-brand-50 text-brand-700 font-bold px-5 py-2.5 rounded-xl transition-colors text-sm flex items-center gap-2 whitespace-nowrap"
            >
              S'abonner <Send size={15} />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
